<p-confirmDialog></p-confirmDialog>

<div class="teams-meeting-dialog">
  <form
    [formGroup]="meetingForm"
    (ngSubmit)="onSubmit()"
    class="p-fluid settings-margin-enforcer"
  >
    <div class="form-grid form-grid--top settings-margin">
      @if (isNewDocentMeeting) {
        <div class="form-group full-width form-hint">
          <i class="pi pi-info-circle"></i> Angelegt wird je Schultag ein
          Meeting, für den serverseitig konfigurierten Zeitraum ab heute.
          Bereits vorhandene Meetings bleiben unverändert — es werden nur
          fehlende Tage ergänzt.
        </div>
      }

      <!-- Name / Betreff -->
      <div class="form-group required-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="tm-dialog-subject"
            formControlName="subject"
            [class.p-invalid]="isInvalid('subject')"
          />
          <label for="tm-dialog-subject">Titel*</label>
        </p-floatLabel>
        @if (isNewDocentMeeting) {
          <small class="field-hint">
            <i class="pi pi-info-circle"></i> Dient als Vorlage: Der Betreff
            jedes Tagesmeetings wird um " am &lt;Datum&gt;" ergänzt. Der Titel
            muss den Dozentennamen enthalten.
          </small>
        }
      </div>

      <!-- Dozenten / Teilnehmer -->
      <div
        class="form-group required-field"
        pTooltip="Die ausgewählten Dozenten werden als Mitorganisatoren der Besprechung gesetzt. Das erlaubt z.B. das Erstellen von Breakout-Räumen durch die Dozenten."
      >
        <p-floatLabel variant="in">
          <p-multiSelect
            id="tm-dialog-participants"
            formControlName="participants"
            [options]="users"
            optionLabel="fullName"
            optionValue="email"
            [showClear]="true"
            appendTo="body"
            scrollHeight="400px"
            [class.p-invalid]="isInvalid('participants')"
          >
            <ng-template let-docent pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div>{{ docent.fullName }} ({{ docent.email }})</div>
              </div>
            </ng-template>
          </p-multiSelect>
          <label for="tm-dialog-participants">Organizer*</label>
        </p-floatLabel>
        @if (isInvalid('participants') &&
        meetingForm.get('participants')?.errors?.['required']) {
        <small class="p-error">
          Bitte mindestens einen Organizer auswählen.
        </small>
        } @if (isInvalid('participants') &&
        meetingForm.get('participants')?.errors?.['invalidLecturerEmails']) {
        <small class="p-error">
          Ungültige Organizer-E-Mail-Adresse. Erlaubt sind nur: {{
          meetingForm.get('participants')?.errors?.['invalidLecturerEmails']?.allowedEmailRules?.join(',
          ') }}
        </small>
        }
      </div>

      <!-- Startzeitpunkt -->
      <div
        class="form-group required-field h-44"
        [pTooltip]="startDateTimeTooltip"
      >
        <p-floatLabel variant="in">
          <p-calendar
            id="tm-dialog-startDateTime"
            formControlName="startDateTime"
            [showIcon]="true"
            [showTime]="true"
            [showSeconds]="false"
            dateFormat="dd.mm.yy"
            hourFormat="24"
            appendTo="body"
            [class.p-invalid]="isInvalid('startDateTime')"
          ></p-calendar>
          <label for="tm-dialog-startDateTime">Startzeitpunkt*</label>
        </p-floatLabel>
      </div>

      <!-- Endzeitpunkt -->
      <div
        class="form-group required-field h-44"
        [pTooltip]="endDateTimeTooltip"
      >
        <p-floatLabel variant="in">
          <p-calendar
            id="tm-dialog-endDateTime"
            formControlName="endDateTime"
            [showIcon]="true"
            [showTime]="true"
            [showSeconds]="false"
            dateFormat="dd.mm.yy"
            hourFormat="24"
            appendTo="body"
            [class.p-invalid]="isInvalid('endDateTime')"
          ></p-calendar>
          <label for="tm-dialog-endDateTime">Endzeitpunkt*</label>
        </p-floatLabel>
        @if (isNewDocentMeeting) {
          <small class="field-hint">
            <i class="pi pi-info-circle"></i> Übernommen wird nur die
            <b>Dauer</b> zwischen Start und Ende. Jedes Tagesmeeting beginnt am
            jeweiligen Schultag und läuft genau so lange — die hier gewählten
            Kalendertage und Uhrzeiten selbst wirken sich nicht aus.
          </small>
        }
        @if(meetingForm.errors && meetingForm.errors['endBeforeOrEqualStart'] &&
        (meetingForm.dirty || meetingForm.touched)) {
        <small class="p-error">
          Endzeitpunkt muss nach dem Startzeitpunkt liegen.
        </small>
        } @if(meetingForm.errors && meetingForm.errors['invalidDuration'] &&
        (meetingForm.dirty || meetingForm.touched)) {
        <small class="p-error">
          Die Dauer des Meetings muss zwischen 1 Minute und 60 Tagen liegen.
        </small>
        }
      </div>
    </div>
    <!-- Additional Settings -->
    @if (showAdvancedSettings) {
    <p-accordion>
      <p-accordionTab
        header="Erweiterte Einstellungen"
        [transitionOptions]="'0ms'"
      >
        <div class="form-grid settings-margin">
          <!-- Ablaufdatum nur sichtbar, wenn ein Meeting bearbeitet wird. -->
          @if(this.meeting) {
          <!-- Ablaufdatum -->
          <div
            class="form-group"
            pTooltip="Datum und Uhrzeit, zu der das Meeting endgültig gelöscht wird. Das Meeting bleibt für 60 Tage aktiv, dieser Timer wird jedoch zurückgesetzt, wenn das Meeting betreten oder aktualisiert wird."
          >
            <app-readonly-float-label label="Ablaufdatum">
              <span>
                {{ meetingForm.get('expirationDateTime')?.value |
                date:'dd.MM.yyyy HH:mm' }}
              </span>
            </app-readonly-float-label>
          </div>
          <div class="form-group">
            <!-- Platzhalter -->
          </div>
          }
          <!-- Lobby Bypass Settings -->
          <div
            class="form-group"
            pTooltip="Bestimmt, wer die Lobby umgehen und direkt dem Meeting beitreten darf"
          >
            <p-floatLabel variant="in">
              <p-dropdown
                id="tm-dialog-lobbyBypassSettings"
                formControlName="lobbyBypassSettings"
                [options]="lobbyBypassSettings"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
              ></p-dropdown>
              <label for="tm-dialog-lobbyBypassSettings">Lobby-Umgehung</label>
            </p-floatLabel>
          </div>

          <!-- Presenter-Einstellungen -->
          <div
            class="form-group"
            pTooltip="Bestimmt, wer in der Besprechung als Präsentator agieren darf; richtige Wahl: 'Nur Organisatoren', dann können Dozenten die Präsentatorenrolle dynamisch zuweisen"
          >
            <p-floatLabel variant="in">
              <p-dropdown
                id="tm-dialog-allowedPresenters"
                formControlName="allowedPresenters"
                [options]="allowedPresentersSettings"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
              ></p-dropdown>
              <label for="tm-dialog-allowedPresenters">Präsentatoren</label>
            </p-floatLabel>
          </div>

          <!-- Meeting Chat erlauben -->
          <div
            class="form-group checkbox-group"
            pTooltip="Erlaubt Teilnehmenden, den Meeting-Chat zu verwenden"
          >
            <p-checkbox
              inputId="tm-dialog-allowMeetingChat"
              formControlName="allowMeetingChat"
              [binary]="true"
            ></p-checkbox>
            <label for="tm-dialog-allowMeetingChat" class="checkbox-label"
              >Meeting-Chat erlauben</label
            >
          </div>

          <!-- Kamera erlauben -->
          <div
            class="form-group checkbox-group"
            pTooltip="Erlaubt Teilnehmenden, die Kamera einzuschalten"
          >
            <p-checkbox
              inputId="tm-dialog-allowAttendeeToEnableCamera"
              formControlName="allowAttendeeToEnableCamera"
              [binary]="true"
            ></p-checkbox>
            <label
              for="tm-dialog-allowAttendeeToEnableCamera"
              class="checkbox-label"
              >Kamera erlauben</label
            >
          </div>

          <!-- Mikrofon erlauben -->
          <div
            class="form-group checkbox-group"
            pTooltip="Erlaubt Teilnehmenden, das Mikrofon einzuschalten"
          >
            <p-checkbox
              inputId="tm-dialog-allowAttendeeToEnableMic"
              formControlName="allowAttendeeToEnableMic"
              [binary]="true"
            ></p-checkbox>
            <label
              for="tm-dialog-allowAttendeeToEnableMic"
              class="checkbox-label"
              >Mikrofon erlauben</label
            >
          </div>

          <!-- Reaktionen erlauben -->
          <div
            class="form-group checkbox-group"
            pTooltip="Erlaubt Teilnehmenden, Reaktionen zu verwenden (z.B. Daumen hoch)"
          >
            <p-checkbox
              inputId="tm-dialog-allowTeamworkReactions"
              formControlName="allowTeamworkReactions"
              [binary]="true"
            ></p-checkbox>
            <label for="tm-dialog-allowTeamworkReactions" class="checkbox-label"
              >Reaktionen erlauben</label
            >
          </div>

          <!-- Automatisch aufzeichnen -->
          <div
            class="form-group checkbox-group"
            pTooltip="Zeichnet das Meeting automatisch auf, sobald es beginnt"
          >
            <p-checkbox
              inputId="tm-dialog-recordAutomatically"
              formControlName="recordAutomatically"
              [binary]="true"
            ></p-checkbox>
            <label for="tm-dialog-recordAutomatically" class="checkbox-label"
              >Automatisch aufzeichnen</label
            >
          </div>

          <!-- Chat Historie teilen, nur beim Erstellen erlaubt -->
          @if(!this.meeting) {
          <div
            class="form-group checkbox-group"
            pTooltip="Teilt die Chat-Historie des Meetings mit den Teilnehmenden"
          >
            <p-checkbox
              inputId="tm-dialog-shareMeetingChatHistory"
              formControlName="shareMeetingChatHistory"
              [binary]="true"
            ></p-checkbox>
            <label
              for="tm-dialog-shareMeetingChatHistory"
              class="checkbox-label"
            >
              Chat-Historie teilen
            </label>
          </div>
          }
        </div>
      </p-accordionTab>
    </p-accordion>
    }

    @if (meeting) {
    <div class="form-grid settings-margin">
      <div class="form-group"></div>
      <div class="form-group">
        <p-button
          size="small"
          type="button"
          pTooltip="Teams Meeting löschen"
          label="Teams Meeting löschen"
          icon="pi pi-trash"
          severity="danger"
          (onClick)="deleteTeamsMeeting($event)"
        >
        </p-button>
      </div>
    </div>
    }

    <!-- Footer Buttons -->
    <div class="dialog-footer">
      <button
        pButton
        type="submit"
        [label]="meeting ? 'Aktualisieren' : 'Erstellen'"
        [icon]="meeting ? 'pi pi-refresh' : 'pi pi-check'"
        class="p-button-success"
        [loading]="isSubmitting"
        [disabled]="!meetingForm.valid || isSubmitting"
      ></button>

      <button
        pButton
        type="button"
        label="Abbrechen"
        icon="pi pi-times"
        class="p-button-secondary"
        (click)="onCancel()"
      ></button>
    </div>
  </form>
</div>
